import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import Datatable from '../../../shared/ui/components/Datatable';
import getDailyCashClosureList from 'src/daily-cash-closure/use-cases/getDailyCashClosureList';
import { User } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const DailyCashClosureDatatable = ({ handleDownload }) => {
  const classes = useStyles();

  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const fetchList = async () => {
    const response = await getDailyCashClosureList({
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    setList(response);
  };

  const navigate = useNavigate();

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  let columnNameList = [
    'date',
    'dailyCashClosureCode',
    'status',
    '${Employee.firstname}${Employee.surnames}',
    'paymentTypeCode',
    'depositNumber',
    'totalAmount',
    'registeredAmount',
    'registeredDifferenceAmount',
    'depositAmount',
    '${UserRegister.firstname}${UserRegister.surnames}',
    '${UserClose.firstname}${UserClose.surnames}'
  ];

  if (localStorage.selectedUserHeadquarter === 'all') {
    columnNameList.unshift('CompanyHeadquarter.name');
  }

  const handleClickEdit = (event, id) => {
    navigate(`/app/daily-cash-closures/${id}`, {
      replace: false
    });
  };

  return (
    <Datatable
      domainName="DAILY_CASH_CLOSURE"
      dataList={list.rows}
      count={list.count}
      title="Listado de cierres diarios"
      exportExcelButton={Boolean(false)}
      onSearch={handleSearch}
      onChangePageValue={handleChangePage}
      onChangePageLimit={handleChangeLimit}
      handleOrderBy={handleOrderBy}
      handleClickEdit={handleClickEdit}
      columnNameList={columnNameList}
    />
  );
};

export default DailyCashClosureDatatable;
